import { Directive, ElementRef, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { InputUtils } from './InputUtils';

@Directive({
    selector: '[inputNormalize]'
})
export class InputNormalizeDirective {
    @Input() inputNormalize: "alfa" | "numeric" | "alfanum" | "email";
    @Input() set disabled(value: boolean) {
        if (value) {
            this._controlContainer.control.disable();
            return;
        }
        this._controlContainer.control.enable();
    }

    constructor(private _el: ElementRef, private _controlContainer: NgControl) {}

    ngAfterViewInit() {
        this._el.nativeElement.addEventListener("input", ($event: any) => {
            switch (this.inputNormalize) {
                case "alfa":
                    InputUtils.onInput($event, "alfa");
                    break;
                case "numeric":
                    InputUtils.onInput($event, "numeric");
                    break;
                case "alfanum":
                    InputUtils.onInput($event, "alfanum");
                    break;
                case "email":
                    InputUtils.onInput($event, "email");
                    break;
            }
        });
        this._controlContainer.control.valueChanges.subscribe((value) => {
            return value;
        });
    }
}
